"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowRight } from "lucide-react";
export default function TheGoldenYearsStory() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="139531" id="我們的故事" className="relative bg-background pt-24 pb-32 lg:pt-32 lg:pb-48 overflow-hidden font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 relative transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
              {}
              <div className="absolute inset-0 z-10 pointer-events-none rounded-3xl shadow-[inset_0_0_80px_var(--color-primary)] opacity-40 mix-blend-multiply transition-opacity duration-700 group-hover:opacity-60"></div>
              <div className="absolute inset-0 z-10 pointer-events-none rounded-3xl shadow-[inset_0_0_40px_var(--color-primary)] opacity-20"></div>
              
              <img src="https://wanted-kite.10web.cloud/wp-content/uploads/2026/03/6-scaled.png" alt="憬芯醫療資深護理團隊專業協作" className="w-full h-auto object-cover aspect-[4/3] lg:aspect-[16/11] transform transition-transform duration-1000 group-hover:scale-105" />
            </div>
            
            {}
            <div className="absolute -top-12 -left-12 w-64 h-64 bg-primary/10 rounded-full blur-3xl -z-10 pointer-events-none"></div>
            <div className="absolute -bottom-12 -right-12 w-80 h-80 bg-secondary rounded-full blur-3xl -z-10 pointer-events-none"></div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 flex flex-col items-start transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <Badge variant="default" className="rounded-full px-5 py-2 text-xs tracking-widest font-bold mb-6 shadow-md bg-primary text-primary-foreground">
              關於我們
            </Badge>
            
            <h2 className="text-4xl font-bold mb-6 leading-tight tracking-tight !rounded-none !font-serif !shadow-none !text-[hsl(264,67%,35%)] !not-italic md:text-5xl">憬於未來，芯繫健康</h2>
            
            <p className="text-lg text-foreground/80 leading-[1.8] mb-8 font-medium">
              憬芯醫療 (Prospect Care) 由資深護理團隊領導，致力為香港家庭提供全方位的居家醫護支援。我們深信每一位服務使用者都是獨立的生命個體，透過熱「芯」建立的個人化復康計劃，我們不僅治癒身體，更療癒心靈，讓長者在熟悉的環境中重拾尊嚴與生活質素。
            </p>
            
            <Button size="lg" className="rounded-full px-10 py-7 text-base font-bold group bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg transition-all" onClick={() => window.location.href = "/AboutUsPage"}>
              探索我們的理念
              <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>

        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0] pointer-events-none z-0">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[80px] md:h-[120px] lg:h-[160px]">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V0C73.8,30.6,150.8,55.3,228.3,67.5,259.4,72.4,290.5,74.2,321.39,56.44Z" className="fill-secondary opacity-50"></path>
        </svg>
      </div>
    </section>;
}